<loader *ngIf="loading && recognitionComponent"></loader>
<div class="otlkParticipantPopupHeader">
    <div class="otlkParticipantPopupHeaderInner dfr jcsb aic" *ngIf = "recognitionComponent">
        <div>
            <button class="otlkBtn otlkBtn--tertiary cp" (click)="closeModalWindow()">
                {{'Participants.Cancel' | translate}}
            </button>
        </div>
        <div>
            <span class="fwb">{{'Participants.To' | translate}}</span>
        </div>
    </div>
    <div class="otlkParticipantPopupHeaderInner dfr jcsb aic" *ngIf = "copyOthers">
        <div>
            <button class="otlkBtn otlkBtn--tertiary cp" (click)="closecopyotherModal()">
                {{'Participants.Cancel' | translate}}
            </button>
        </div>
        <div>
            <span class="fwb">{{'CopyOthers.CopyOthersHeader' | translate}}</span>
        </div>
    </div>
</div>

<div class="otlkParticipantPopupContent flexGrow">
    <div class="searchWrap">

        <!-- Add "searchWrapSearch--focus" class to below div when on focus to bring up the blue border color -->
        <div class="searchWrapSearch dfr" [ngClass]="{'searchWrapSearch--focus': isSearchFocus}">
            <!-- Below span should be hidden when the input box below the span is focussed -->


            <!-- Below spans are the user name tags. These should be added for each user -->
            <div *ngIf="recognitionComponent">
            <span class="otlkBadge otlkBadgeWithClose dib ml5" *ngFor="let participant of selectedParticipants">
                <span>{{participant.firstName}} {{participant.lastName}} </span>
                <span class="otlkBadgeClose" (click)="removeParticipant(participant)">
                    <fa-icon [icon]="faTimes"></fa-icon>
                </span>
            </span>
            </div>
            <div *ngIf="copyOthers">
                <span class="otlkBadge otlkBadgeWithClose dib ml5" *ngFor="let participant of selectedCopyothersParticipants">
                    <span>{{participant.firstName}} {{participant.lastName}} </span>
                    <span class="otlkBadgeClose" (click)="removeParticipant(participant)">
                        <fa-icon [icon]="faTimes"></fa-icon>
                    </span>
                </span>
                </div>
            <span class="searchWrapSearchIconHolder">
                <i class="gg-search searchWrapSearchIcon" *ngIf="!isSearchFocus"></i>
                <input type="text" #searchBox class="searchWrapSearchInput" [formControl]="searchInputName"
                    [placeholder]="selectedParticipants.length==0 ? ('Participants.SearchByLastName' | translate) : ''"
                    tabindex="0"/>    
                <span class="searchWrapSearchMiniLoader">
                    <miniloader *ngIf="miniLoading"></miniloader>
                </span>  
                              
                <span class="searchWrapAdvanceSearchIcon" [ngbTooltip]="('Participants.AdvancedFilter.Filters' | translate)" placement="top" container="body" aria-label="('Participants.AdvancedFilter.Filters' | translate)" [ngClass]="{'customBg': advanceSearch.count > 0}"
                    (click)="openAdvanceFilterModal()">
                    <span class="totalCount">{{advanceSearch.count > 0 ? advanceSearch.count : ''}}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13.022" viewBox="0 0 20 13.022">
                        <g id="Group_13823" data-name="Group 13823" transform="translate(-1160)">
                            <path id="icon-filter"
                                d="M157.231,161.766a.7.7,0,0,1,0-1.4h2.322a.7.7,0,0,1,0,1.4Zm-4.644-5.811a.7.7,0,1,1,0-1.4h11.622a.7.7,0,1,1,0,1.4Zm-3.489-5.811a.7.7,0,1,1,0-1.4h18.6a.7.7,0,1,1,0,1.4Z"
                                transform="translate(1011.602 -148.744)" />
                        </g>
                    </svg>
                </span>
            </span>
        </div>

        <!-- Below div to be shown when user searches for any participant. Simply hardcoding ngIf to false for now -->
        <div class="searchWrapResultsHolder" style="z-index: 100;" *ngIf="openAutoComplete && hideSearchSuggestions">
            <div class="searchWrapResults">
                <p class="searchWrapResultsFilterTitle" *ngIf="advanceSearch.count > 0">
                    <span class="fixedIcon">
                        <svg _ngcontent-cuk-c118="" xmlns="http://www.w3.org/2000/svg" width="20" height="13.022" viewBox="0 0 20 13.022"><g _ngcontent-cuk-c118="" id="Group_13823" data-name="Group 13823" transform="translate(-1160)"><path _ngcontent-cuk-c118="" fill="#0078D7" id="icon-filter" d="M157.231,161.766a.7.7,0,0,1,0-1.4h2.322a.7.7,0,0,1,0,1.4Zm-4.644-5.811a.7.7,0,1,1,0-1.4h11.622a.7.7,0,1,1,0,1.4Zm-3.489-5.811a.7.7,0,1,1,0-1.4h18.6a.7.7,0,1,1,0,1.4Z" transform="translate(1011.602 -148.744)"></path></g></svg>
                    </span>            
                    <span class="pl-2">{{advanceSearch.count}} {{'Participants.AppliedFilters' | translate}}</span>
                    <a (click)="resetAdvanceSearch()" class="resetBtn">{{'Participants.AdvancedFilter.Reset' | translate}}</a>
                </p>
                <p class="searchWrapResultsTitle">
                    <span *ngIf="!showSearchError">{{'Participants.SuggestedPeople' | translate}}</span>
                    <span *ngIf="showSearchError">{{'Participants.RefineSearchCriteria' | translate}}</span>
                </p>
                <ul class="userListWrapList" id="userListWrapList" (keydown)="onKeydown($event)" tabindex="0">
                    <!-- To be repeated for each user -->
                    <list-item *ngFor="let participant of searchParticipants" class="userListWrapListItemComp"
                        [participant]="participant" (click)="selectParticipant(participant)"
                        (itemSelected)="selectParticipant($event)">
                    </list-item>
                </ul>
               
            </div>
        </div>
    </div>

    <div class="otlkAccordianWrap mt15">
        <div class="otlkAccordianWrapOverlay" *ngIf="openAutoComplete && hideSearchSuggestions"></div>
        <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0,ngb-panel-1,ngb-panel-2" *ngIf="recognitionComponent">
            <ngb-panel id="ngb-panel-0" *ngIf="recentParticipants.length>0">
                <ng-template ngbPanelHeader let-opened="opened">
                    <i class="accordianHeaderIcon gg-chevron-right" [ngClass]="{'collapsed': !opened}"></i>
                    <button ngbPanelToggle class="btn btn-link container-fluid text-left pl-0">
                        <span>
                            {{'Participants.Recent' |translate}}
                        </span>
                    </button>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="userListWrap">
                        <ul class="userListWrapList">
                            <!-- To be repeated for each user -->
                            <li class="userListWrapListItem" (click)="selectParticipant(participant)"
                                *ngFor="let participant of recentParticipants">
                                <div class="userListWrapListItemAvatar" [ngbPopover]="popContent"
                                    triggers="mouseenter:mouseleave" placement="right" container="body">
                                    <!-- Either image or User Initials : Hide the other one -->
                                    <img *ngIf="participant.avatarUrl && participant.avatarUrl!=''"
                                        [src]="participant.avatarUrl" alt="Avatar" style="width: 100%;">
                                    <span *ngIf="!participant.avatarUrl"
                                        class="userListWrapListItemAvatarInitals">{{getShortName(participant.firstName,
                                        participant.lastName)}}</span>
                                    <ng-template #popContent>
                                        <p class="userListWrapListItemDept userListWrapListItemInfo breakWord">
                                            <span class="userListWrapListItemInfo breakWord">{{participant.orgName}},
                                                {{participant.countryName}}</span>
                                        </p>
                                        <p class="userListWrapListItemDept userListWrapListItemInfo">
                                            <span class="userListWrapListItemInfo">{{participant.departmentName}},
                                                {{participant.jobName}} </span>
                                        </p>
                                    </ng-template>
                                </div>
                                <div class="userListWrapListItemContent">
                                    <p class="userListWrapListItemUser">{{participant.firstName}}
                                        {{participant.lastName}}</p>
                                    <p class="userListWrapListItemEmail userListWrapListItemInfo">
                                        {{participant.emailAddress}}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel id="ngb-panel-1" *ngIf="showRATab && raParticipants.length>0">
                <ng-template ngbPanelHeader let-opened="opened">
                    <i class="accordianHeaderIcon gg-chevron-right" [ngClass]="{'collapsed': !opened}"></i>
                    <button ngbPanelToggle
                        class="btn btn-link container-fluid text-left pl-0"><span>{{'Participants.Recommended' |
                            translate}}</span></button>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="userListWrap">
                        <ul class="userListWrapList">
                            <!-- To be repeated for each user -->
                            <li class="userListWrapListItem" (click)="selectParticipant(participant)"
                                *ngFor="let participant of raParticipants">
                                <div class="userListWrapListItemAvatar" [ngbPopover]="rapopContent"
                                    triggers="mouseenter:mouseleave" placement="right" container="body">
                                    <img *ngIf="participant.avatarUrl && participant.avatarUrl!=''"
                                        [src]="participant.avatarUrl" alt="Avatar" style="width: 100%;">
                                    <span *ngIf="!participant.avatarUrl"
                                        class="userListWrapListItemAvatarInitals">{{getShortName(participant.firstName,
                                        participant.lastName)}}</span>

                                    <ng-template #rapopContent>
                                        <p class="userListWrapListItemDept userListWrapListItemInfo breakWord">
                                            <span class="userListWrapListItemInfo breakWord">{{participant.orgName}},
                                                {{participant.countryName}}</span>
                                        </p>
                                        <p class="userListWrapListItemDept userListWrapListItemInfo">
                                            <span class="userListWrapListItemInfo">{{participant.departmentName}},
                                                {{participant.jobName}} </span>
                                        </p>
                                    </ng-template>
                                </div>
                                <div class="userListWrapListItemContent">
                                    <p class="userListWrapListItemUser">{{participant.firstName}}
                                        {{participant.lastName}}</p>
                                    <p class="userListWrapListItemEmail userListWrapListItemInfo">
                                        {{participant.emailAddress}}
                                    </p>
                                    <p class="userListWrapListItemDept userListWrapListItemInfo">
                                        <span class="userListWrapListItemInfo userListWrapListItemInfo--colorDanger">
                                            {{'Participants.NotBeenRecognized' | translate}}
                                            {{participant.lastRecognitionDays}} {{'Participants.Days' |
                                            translate}}</span>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </ngb-panel>
            <ngb-panel id="ngb-panel-2" *ngIf="participants.length>0">
                <ng-template ngbPanelHeader let-opened="opened">
                    <i class="accordianHeaderIcon gg-chevron-right" [ngClass]="{'collapsed': !opened}"></i>
                    <button ngbPanelToggle
                        class="btn btn-link container-fluid text-left pl-0"><span>{{'Participants.Team'
                            | translate}}</span></button>
                </ng-template>
                <ng-template ngbPanelContent>
                    <div class="userListWrap">
                        <ul class="userListWrapList">
                            <!-- To be repeated for each user -->
                            <li class="userListWrapListItem" (click)="selectParticipant(participant)"
                                *ngFor="let participant of participants">
                                <div class="userListWrapListItemAvatar" [ngbPopover]="teamContent"
                                    triggers="mouseenter:mouseleave" placement="right" container="body">
                                    <!-- Either image or User Initials : Hide the other one -->
                                    <img *ngIf="participant.avatarUrl && participant.avatarUrl!=''"
                                        [src]="participant.avatarUrl" alt="Avatar" style="width: 100%;">
                                    <span *ngIf="!participant.avatarUrl"
                                        class="userListWrapListItemAvatarInitals">{{getShortName(participant.firstName,
                                        participant.lastName)}}</span>
                                    <ng-template #teamContent>
                                        <p class="userListWrapListItemDept userListWrapListItemInfo breakWord">
                                            <span class="userListWrapListItemInfo breakWord">{{participant.orgName}},
                                                {{participant.countryName}}</span>
                                        </p>
                                        <p class="userListWrapListItemDept userListWrapListItemInfo">
                                            <span class="userListWrapListItemInfo">{{participant.departmentName}},
                                                {{participant.jobName}} </span>
                                        </p>
                                    </ng-template>
                                </div>
                                <div class="userListWrapListItemContent">
                                    <p class="userListWrapListItemUser">{{participant.firstName}}
                                        {{participant.lastName}}</p>
                                    <p class="userListWrapListItemEmail userListWrapListItemInfo">
                                        {{participant.emailAddress}}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
        <div class="otlkParticipantPopupFooter" *ngIf="recognitionComponent">
            <button class="otlkBtn otlkBtn--primary cp w100" (click)="saveParticipant()">
                {{'Participants.DoneAdding' | translate}}
            </button>
        </div>
        <div class="otlkParticipantPopupFooter" *ngIf="copyOthers">
            <button class="otlkBtn otlkBtn--primary cp w100" (click)="savecopyotherModal()">
                {{'Participants.DoneAdding' | translate}}
            </button>
        </div>
    </div>
</div>